import React from 'react';


import Button from 'selfly-ui-react/dist/components/Button';
import { useGlobalStore } from "../../services/GlobalStoreService/GlobalStoreHooks";

import './map-legend.scss';

export default function MapLegend(props) {

    
    const [isVisible, setVisibility] = useGlobalStore("map-legend-open", true);

    function close() {
        setVisibility(false);
    }

    function open() {
        setVisibility(true);
    }

    if(!isVisible) {
        return (
            <Button className="open-legend" onClick={open} icon="help_outline" size="lg" />
        )
    }

    return (
        <div className="map-legend">
            <div className="header">
                <p>Map Legend</p>
                <Button className="close" onClick={close} icon="close" size="sm" />
            </div>
            
            {props.children}
        </div>
    )
}